import { render, staticRenderFns } from "./patient-messages-settings.vue?vue&type=template&id=05bf8d3e&scoped=true"
import script from "./patient-messages-settings.vue?vue&type=script&lang=js"
export * from "./patient-messages-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf8d3e",
  null
  
)

export default component.exports